import instance from '../utils/axios';

class ActivityService {

    async getActivityById(activityId,cropId) {
        return await instance.get('/crm/activity/getActivityWithOutToken?uuid='+activityId+'&cropId='+cropId);
    }

    async customerReportActivity(activityId,cropId,advisorId,name,mobile,workUnit,key,code,biz) {
        return await instance.post('/crm/activity/customerReportActivity',{
            activityId:activityId,
            cropId:cropId,
            advisorId:advisorId,
            name:name,
            mobile:mobile,
            key:key,
            code:code,
            workUnit:workUnit,
            biz:biz
        });
    }
}
export default new ActivityService();